import client from '../client.js';
import createQuery from './create.graphql';
import getQuery from './get.graphql';
import addQuery from './add.graphql';
import updateQuery from './update.graphql';
import removeQuery from './remove.graphql';
import costQuery from './cost.graphql';

export const createCart = async function (input) {
    let result = await client.request(createQuery, input);
    return result.cartCreate.cart.id;
};
export const getCart = async function (input) {
    try {
        let result = await client.request(getQuery, input);
        return {
            lines: result.cart.lines.edges,
            subtotal: result.cart.estimatedCost?.subtotalAmount?.amount || 0,
        };
    } catch (err) {
        return null;
    }
};
export const addToCart = async function (input) {
    let result = await client.request(addQuery, input);
    return {
        lines: result.cartLinesAdd.cart.lines.edges,
        subtotal: result.cartLinesAdd.cart.estimatedCost?.subtotalAmount?.amount || 0,
    };
};
export const updateCart = async function (input) {
    let result = await client.request(updateQuery, input);
    return {
        lines: result.cartLinesUpdate.cart.lines.edges,
        subtotal: result.cartLinesUpdate.cart.estimatedCost?.subtotalAmount?.amount || 0,
    };
};
export const removeFromCart = async function (input) {
    let result = await client.request(removeQuery, input);
    return {
        lines: result.cartLinesRemove.cart.lines.edges,
        subtotal: result.cartLinesRemove.cart.estimatedCost?.subtotalAmount?.amount || 0,
    };
};
// export const estimatedCost = async function (input) {
//     let result = await client.request(costQuery, input);
//     return result;
// };
